<template>
  <div class="user-menu">
    <MenuBaseComponent :menu-properties="menuProperties" />
  </div>
</template>

<script>
import MenuBaseComponent from "@/components/navigation/menu/utils/MenuBaseComponent";
import {userDetails, announcements, contactMe, generateEfp, generateValidation,kanonismoi} from "@/config/menuopts"
export default {
  name: "UserMenu",
  components: {MenuBaseComponent},
  data() {
    return {
      menuProperties: {
        userDetails,
        announcements,
        contactMe,
        generateEfp,
        generateValidation
      }
    }

  }
}
</script>

<style scoped>

</style>